import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    containerLeft:{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      color: '#666666',
      padding: '15px',
      fontSize: '1.2em'
    },
    containerRight:{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      color: '#666666',
      padding: '15px',
      fontSize: '1.2em',
      textAlign: 'right'
    },
    messageReceiver: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    },
    messageSender: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%'
    },
    messageHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      marginLeft: '10px'
    },
    header:{
      display:'flex'
    },
    subHeader: {
      display:'flex'
    },
    bodyReceiver:{
      paddingTop: '5px',
      marginLeft: '10px',
      display: 'flex',
      flexDirection: 'row'
    },
    bodySender:{
      paddingTop: '5px',
      marginLeft: '10px',
      display: 'flex',
      flexDirection: 'row-reverse'
    }
}));

export default useStyles;
